import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import createCustomTheme from './../theme/theme';
import store from './store';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { AppRootContainer } from './app-root/app-root.container';
import AnalyticsRouteTracker from '../components/AnalyticsRouteTracker';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../App.css'
import '../styles/global-responsive.css'

const theme = createCustomTheme('#0F2437', '#fafafa');

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <AnalyticsRouteTracker />
          <ToastContainer />
          <LocalizationProvider dateAdapter={AdapterLuxon}>
            <AppRootContainer />
          </LocalizationProvider>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
